import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import { autobind } from 'core-decorators';

import { byIdShape } from 'utils/propTypes';

import NavLink from 'AppComponents/NavLink';
import UserImage from 'AppComponents/UserImage';
import Dropdown, { DropdownMenu, DropdownToggle } from 'AppComponents/Dropdown';

import Search from './Search';

import './styles.scss';


class Header extends Component {

  static propTypes = {
    chargersById: byIdShape,
    currentPath: PropTypes.string,
    currentRoute: PropTypes.string.isRequired,
    currentUser: byIdShape,
    handleLogout: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool,
    loggingIn: PropTypes.bool,
    loggingOut: PropTypes.bool,
    onSearchResultClick: PropTypes.func,
  };

  static defaultProps = {
    chargersById: {},
    currentPath: null,
    currentUser: null,
    isLoggedIn: false,
    loggingIn: false,
    loggingOut: false,
    onSearchResultClick: () => {},
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      collapsed: true,
      searchCollapsed: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentPath !== this.props.currentPath) {
      this.setState({ collapsed: true });
    }
  }

  handleSearchClick() {
    this.setState({ searchCollapsed: !this.state.searchCollapsed });
  }

  @autobind
  handleLogout(e) {
    e.preventDefault();
    this.props.handleLogout();
  }

  isActive(path) {
    return this.props.currentPath === path;
  }

  activeClass(path, classStr = '') {
    if (this.isActive(path)) {
      const classes = ['active'];
      if (classStr !== '') classes.unshift(classStr);
      return classes.join(' ');
    }
    return classStr;
  }

  render() {
    const {
      isLoggedIn, loggingIn, loggingOut, currentUser, currentRoute, chargersById } = this.props;
    const { collapsed, searchCollapsed } = this.state;
    return (
      <header>
        <nav className='navbar navbar-toggleable-sm navbar-inverse bg-primary' styleName='navbar'>

          <div styleName='not-links'>
            <Link to='/' className='navbar-brand' styleName='logo'>Chargerville</Link>

            <div styleName='toggles'>
              <button
                type='button'
                className={classNames('navbar-toggler', { collapsed, active: !collapsed })}
                onClick={() => this.setState({ collapsed: !collapsed })}
                aria-expanded={collapsed ? 'false' : 'true'}
              >
                <span className='navbar-toggler-icon' />
              </button>

              <button
                type='button'
                className={classNames('navbar-toggler', 'search-toggle', {
                  collapsed: searchCollapsed,
                  active: !searchCollapsed,
                })}
                onClick={() => this.setState({ searchCollapsed: !searchCollapsed })}
                aria-expanded={searchCollapsed ? 'false' : 'true'}
              >
                <span className='sr-only'>Toggle search</span>
              </button>

              <div
                className={classNames(
                  'collapse',
                  'navbar-collapse',
                  'navbar-search', {
                    show: !searchCollapsed,
                  },
                )}
                styleName='navbar-collapse navbar-search'
              >
                <Search
                  chargersById={chargersById}
                  onResultClick={this.props.onSearchResultClick}
                />
              </div>
            </div>

          </div>

          <div
            className={classNames('collapse', 'navbar-collapse', { show: !collapsed })}
            id='navbar-collapse'
            styleName='navbar-collapse'
          >

            <ul className='navbar-nav'>

              { isLoggedIn ?

                <Dropdown
                  currentRoute={currentRoute}
                  className={this.activeClass('/user/account', 'user-account-item')}
                  styleName='user-account-item'
                >

                  <Link to='/user/account/'>
                    <div styleName='with-image'>
                      <UserImage user={currentUser} />
                      <div className='navbar-text' styleName='text'>{currentUser.first_name || currentUser.username}</div>
                    </div>
                  </Link>

                  <DropdownToggle />

                  <DropdownMenu right>

                    <Link
                      to='/user/account/'
                      className='dropdown-item'
                      activeClassName='active'
                    >
                      My Account
                    </Link>

                    <li role='separator' className='dropdown-divider' />

                    <li>
                      <a href='/user/logout/' onClick={this.handleLogout} className='dropdown-item'>
                        { loggingOut ? `Logging Out${String.fromCharCode(8230)}` : 'Logout' }
                      </a>
                    </li>

                  </DropdownMenu>

                </Dropdown>

              : null }

              { !isLoggedIn && loggingIn ?

                <NavLink to='/user/login/'>Logging In&hellip;</NavLink>

              : null }

              { !isLoggedIn && !loggingIn ? [

                <NavLink key='register' to='/user/register/'>Register</NavLink>,
                <NavLink key='login' to='/user/login/'>Login</NavLink>,

              ] : null }

            </ul>

            <ul className='nav navbar-nav hidden-md-up'>

              <NavLink to='/about/'>About</NavLink>

              <NavLink to='/privacy/'>Privacy Policy</NavLink>

              <NavLink to='/contact/'>Contact</NavLink>

            </ul>

          </div>

        </nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Header/index.jsx